export enum SupportedPrismicSlicesEnum {
    blog = 'blog',
    cta = 'cta',
    faq = 'faq',
    feature = 'feature',
    featured_artists = 'featured_artists',
    hero = 'hero',
    logoList = 'logo_list',
    mastering_demos = 'mastering_demos',
    pressList = 'press_list',
    pricing = 'pricing',
    quotes = 'quotes',
    quotes_video = 'quotes_-_video',
    reset_password = 'reset_password',
    signup = 'signup',
    textBlock = 'text_block',
    text_grid = 'text_grid',
    videoplayer = 'videoplayer',
    visual = 'visual',
    linklist = 'linklist',
}

export enum PrismicLinkTypes {
    external = 'Link.web',
    internal = 'Link.document',
}
